import { render, staticRenderFns } from "./workersList.vue?vue&type=template&id=63d15b8e&scoped=true"
import script from "./workersList.vue?vue&type=script&lang=js"
export * from "./workersList.vue?vue&type=script&lang=js"
import style0 from "./workersList.vue?vue&type=style&index=0&id=63d15b8e&prod&lang=less"
import style1 from "./workersList.vue?vue&type=style&index=1&id=63d15b8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d15b8e",
  null
  
)

export default component.exports